<template>
  <div
    class="asset-metadata-component"
    :class="{ tile }"
  >
    <icon
      class="metadata-icon"
      :name="asset.icon"
      :variant="iconVariant === 'mastery' ? 'mastery' : '555555'"
    />
    <hlt-text
      :inline="true"
      :size="'sm'"
      :variant="'content-secondary'"
    >
      <template v-if="metadata">
        {{ metadata }}
      </template>
      <template v-if="difficultyLabel">
        <span class="bold">&middot;</span> {{ difficultyLabel }}
      </template>
    </hlt-text>
  </div>
</template>

<script>
import Icon from '@/components/singletons/icon.vue';
import HltText from '@/components/ui/text.vue';

export default {
  components: { Icon, HltText },
  props: {
    asset: {
      type: Object,
    },
    iconVariant: {
      type: String,
      default: 'content-secondary',
    },
    // true if metadata is used within context of a card/tile ui
    tile: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    difficultyLabel() {
      if (typeof this.asset?.difficultyLabel !== 'function') {
        return null;
      }
      return this.asset?.difficultyLabel(this.$store);
    },
    metadata() {
      // return early if cardMetadata is not a function
      if (typeof this.asset?.cardMetadata !== 'function') {
        return null;
      }
      return this.asset?.cardMetadata(this.$store);
    },
  },
};
</script>

<style lang="scss" scoped>
.asset-metadata-component {
  align-items: center;
  display: flex;
  margin-top: rem-calc(8);

  &.tile {
    margin-top: rem-calc(8);
  }

  .metadata-icon {
    height: rem-calc(16);
    margin-right: rem-calc(12);
    width: rem-calc(16);
  }
}
</style>
